import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const authToken = JSON.parse(localStorage.getItem("accinf"));
  if (authToken) config.headers.Authorization = "Bearer " + authToken;
  return config;
});

export default api;
